
import { css } from 'lit';
export default css`
:host{
  display:block;
  background-color:var(--neutral-light);
  padding-top:var(--spacing-8);
  padding-bottom:var(--spacing-8);
}

.inner{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-8);
}

.button{
  cursor:pointer;
  border:none;
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body);
  font-family:var(--ff-body);
}

.button--close{
  background:transparent;
  padding:0;
}

.button--show-filters{
  display:inline-flex;
  justify-content:center;
  align-items:center;
  gap:var(--spacing-2);
  border-radius:8px;
  background-color:var(--purple-indigo);
  padding:var(--spacing-4);
  color:var(--primary-white);
}

.button--show-filters .button__label{
  width:85%;
  text-overflow:ellipsis;
  text-wrap:nowrap;
  overflow:hidden;
}

.counter{
  display:inline-flex;
  flex-shrink:0;
  justify-content:center;
  align-items:center;
  border-radius:100%;
  background-color:var(--primary-white);
  width:18px;
  height:18px;
  color:var(--purple-indigo);
  font-size:var(--fs-caption);
}

::slotted([slot='search']){
  width:100%;
}

::slotted([slot='ancillary-filters']){
  display:none;
}

::slotted([slot='filters']){
  position:relative;
}

@media (max-width: 767px){
  .filters{
    display:none;
    inset:0;
    background-color:var(--primary-white);
  }

  .filters.is-expanded{
    display:block;
    z-index:20;
    overflow-y:auto;
    position:fixed;
  }

  .filters__header{
    display:flex;
    position:fixed;
    top:0;
    right:0;
    left:0;
    justify-content:space-between;
    align-items:center;
    background-color:var(--neutral-light);
    padding:var(--spacing-4) var(--spacing-8);
    z-index:1;
  }

  .filters__header .title{
    display:inline-flex;
    gap:var(--spacing-2);
    font-size:var(--fs-h5-mobile);
    line-height:var(--lh-h5);
    align-items:center;
  }

  .filters__content{
    padding-top:56px;
    padding-bottom:56px;
  }

  .filters__footer{
    position:fixed;
    right:0;
    bottom:0;
    left:0;
  }

  .button--view-results{
    display:flex;
    justify-content:center;
    align-items:center;
    gap:var(--spacing-2);
    border-radius:8px 8px 0px 0px;
    background-color:var(--purple-indigo);
    padding:var(--spacing-4) var(--spacing-8);
    width:100%;
    color:var(--primary-white);
    font-weight:var(--fw-medium);
  }
}

@media (min-width: 768px){
  .filters__header,
  .filters__footer{
    display:none;
  }

  .button--show-filters{
    display:none;
  }

  ::slotted([slot='filters']){
    display:grid;
    grid-template-columns:repeat(4, 1fr);
    grid-template-columns:repeat(var(--template-columns-tablet, 4), 1fr);
    gap:var(--spacing-4);
  }

  ::slotted([slot='ancillary-filters']){
    display:flex;
    flex-wrap:wrap;
    gap:var(--spacing-4);
  }
}

@media (min-width: 992px){
  :host{
    padding-top:var(--spacing-12);
    padding-bottom:var(--spacing-12);
  }

  ::slotted([slot='search']){
    margin:0 auto;
    width:65%;
  }

  ::slotted([slot='filters']){
    grid-template-columns:repeat(5, 1fr);
    grid-template-columns:repeat(var(--template-columns-desktop, 5), 1fr);
    gap:var(--spacing-6);
  }
}

@media (min-width: 1440px){
  ::slotted([slot='filters']){
    grid-template-columns:repeat(7, 1fr);
    grid-template-columns:repeat(var(--template-columns-ultrawide, 7), 1fr);
  }
  ::slotted([slot='ancillary-filters']){
    justify-content:space-between;
  }
}
`;